import React from 'react';
import server from '../../server';
import CpfInput from '../../inputs/CpfInput';
import CepInput from '../../inputs/CepInput';
import TelephoneInput from '../../inputs/TelephoneInput';
import CnpjInput from '../../inputs/CnpjInput';

const styles={
    div:{
        backgroundColor:"#eeeeee",
        padding:"10px 20px",
        height:"100%"
    },

    p:{
        fontSize:12,
        fontWeight:"bold",
        marginBottom:"20px"

    }
}

class ClinicRegister extends React.Component{
	state = {
        message: "",
        specialty_id: 0,
        page: 0,
        registerMode: 1

	}

	componentWillMount(){
        let clinic_data = JSON.parse(localStorage.getItem("clinic"));
        let user_data = JSON.parse(localStorage.getItem("user"));
        this.setState({clinic_data:clinic_data,user_data:user_data})
    }

	updateState = (event) => {
		this.setState({[event.target.id]:event.target.value,[event.target.id + "_error"]:false});
    }

    clear = () =>{
        let state = {
            message: "",
            specialty_id: 0,
            page: 0,
            register: 1
        }

        this.state = state;
    }
    
    check = () =>{
        let newState = this.state;
        let failed = false;

        Object.keys(this.state).forEach(key => {
            if(typeof(newState[key]) == "boolean"){
                newState[key] = false
            }
        })

        this.setState({newState})

        if(this.state.secretaryName == null || this.state.secretaryName == ""){
            this.setState({secretaryName_error: true})
            failed = true;
        }

        if(this.state.secretaryCpf == null || this.state.secretaryCpf.indexOf("_") != -1){
            this.setState({secretaryCpf_error: true})
            failed = true;
        }

        if(this.state.secretaryEmail == null || this.state.secretaryEmail.split("@")[0] == ""){
            this.setState({secretaryEmail_error: true})
            failed = true;
        }

        if(this.state.registerMode == 2 && (this.state.cnpj == null || this.state.cnpj == "")){
            this.setState({cnpj_error:true})
            failed = true;
        }

        if(this.state.registerMode == 1 && (this.state.cpfDoctor == null || this.state.cpfDoctor == "")){
            this.setState({cpfDoctor_error:true})
            failed = true;
        }

        console.log(failed)

        if(!failed) this.next();
    }

    nextPage = () =>{
        let newState = this.state;
        let failed = false;

        Object.keys(this.state).forEach(key => {
            if(typeof(newState[key]) == "boolean"){
                newState[key] = false
            }
        })

        this.setState({newState})
        if(this.state.name == "" || this.state.name == null){
            this.setState({name_error:true})
            this.props.alert("Faltando Informações!", "Insira um nome válido", "warning");
            failed = true
        }

        if(this.state.telephone == null || this.state.telephone == "" || this.state.telephone.replace(/_/g,"").length < 13){
            this.setState({telephone_error:true})
            this.props.alert("Faltando Informações!", "Insira um telefone válido", "warning");
            failed = true
        }

        if(this.state.cep == null || this.state.cep == "" || this.state.cep.indexOf("_") != -1){
            this.setState({cep_error:true})
            this.props.alert("Faltando Informações!", "Insira um cep válido", "warning");
            failed = true
        }

        if(this.state.street == null || this.state.street == ""){
            this.setState({street_error:true})
            this.props.alert("Faltando Informações!", "Insira um endereço válido", "warning");
            failed = true
        }

        if(this.state.city == null || this.state.city == ""){
            this.setState({city_error:true})
            this.props.alert("Faltando Informações!", "Insira uma cidade válida", "warning");
            failed = true
        }

        if(this.state.number == null || this.state.number == ""){
            this.setState({number_error:true})
            this.props.alert("Faltando Informações!", "Insira um número válido", "warning");
            failed = true
        }

        if(this.state.neighborhood == null || this.state.neighborhood == ""){
            this.setState({neighborhood_error:true})
            this.props.alert("Faltando Informações!", "Insira um bairro válido", "warning");
            failed = true
        }

        if(this.state.uf == null || this.state.uf == ""){
            this.setState({uf_error:true})
            this.props.alert("Faltando Informações!", "Insira um estado válido", "warning");
            failed = true
        }

        if(!failed)
            this.setState({page:this.state.page + 1})
    }

	next = () => {

		server.register_clinic(this.state,
             () => {this.props.alert("Sucesso!","Clínica cadastrada com sucesso","success"); this.clear()},
			 (data) => this.props.alert("Erro...","Tente novamente mais tarde.","error"))
	}

	render(){
		// Check for CEP
		if(this.state.cep){
				let cepNumber = this.state.cep.replace(/\-/,"").replace(/\_/,"")
				if(cepNumber.length == 8){
					if(!this.state.cep_loaded){
							fetch(server.address + "/cep/" + cepNumber,{
									method: "GET"
							}).then(response => response.json().then(data => {
									this.setState({street:data.endereco,neighborhood:data.bairro,uf:data.uf,city:data.cidade,street_error:false,neighborhood_error:false,uf_error:false})
							}))
							this.setState({cep_loaded:true})
					}
				}else{
					if(this.state.cep_loaded){
							this.setState({cep_loaded:false})
					}
				}
        }
        return(
            <div class="col1-app">
                <div class="col1-app__wrapper inner-content">
                    <div class="col2-list">
                        <div class="peers w-100p ai-c jc-sb content-header pX-0">
                            <div class="pos-a w-100p peers jc-c pY-20 ">
                                <div class="peers ai-c mX-5">
                                    <span class={this.state.page == 0 ? "step-number mR-5 p-5 c-client-default-inverse bgc-client-default" : "step-number mR-5 p-5 c-client-default-inverse bgc-client-secondary"}>1</span>
                                    <span class={this.state.page == 0 ? "c-client-default step-text" : "c-client-secondary step-text"}>
                                        <b>Dados Clínica</b>
                                    </span>
                                </div>
                                <div class="peers ai-c mX-5">
                                    <span class={this.state.page == 1 ? "step-number mR-5 p-5 c-client-default-inverse bgc-client-default" : "step-number mR-5 p-5 c-client-default-inverse bgc-client-secondary"}>2</span>
                                    <span class={this.state.page == 1 ? "c-client-default step-text" : "c-client-secondary step-text"}>Dados Secretária</span>
                                </div>
                            </div>
                        </div>
                        <div class="scrollable h-100p">
                            <div class="content-data peers  ai-c jc-c">
                                <div class="clinic-register mT-30 mB-30">
                                    <form action="" class="mB-30">
                                    {this.state.page == 0 ?
                                        <div class="aba1-data">
                                            <h4 class="m-0  mB-10">
                                                <i class=" fa fa-hospital-o mR-10 mB-10 c-client-default"></i>Dados da clínica</h4>
                                            <div class="mB-30">
                                                <div class="form-group col-md-6">
                                                    <label for="inputName">Nome</label>
                                                    <input style={this.state.name_error ? {borderColor:"red"} : {}} id="name" onChange={this.updateState} value={this.state.name} class="form-control" name="inputName" placeholder="Nome da clínica" required="" type="text"/>
                                                </div>
                                                <div class="form-group col-md-6">
                                                        <label for="inputType">Especialização</label>
                                                        <select onChange={this.updateState} value={this.state.specialty_id} id="specialty_id" class="form-control" name="inputType">
                                                            <option value="0">Ortopedia</option>
                                                            <option value="1">Geriatria</option>
                                                            <option value="2">Neurologia</option>
                                                            <option value="3">Otorrinolaringologia</option>
                                                            <option value="4">Cardiologia</option>
                                                            <option value="5">Pneumologia</option>
                                                        </select>
                                                    </div>
                                                <div class="form-group col-md-6">
                                                    <label for="inputPhone">Telefone</label>
                                                    <TelephoneInput style={this.state.telephone_error ? {borderColor:"red"} : {}} onChange={this.updateState} value={this.state.telephone} id="telephone" class="form-control" name="inputPhone" placeholder="Telefone" type="text"/>
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <label for="inputCep">Telefone Resp.</label>
                                                    <TelephoneInput class="form-control" name="inputCep" placeholder="Telefone responsável" required="" type="text"/>
                                                </div>

                                                <div class="form-group col-md-3">
                                                    <label for="inputCep">CEP</label>
                                                    <CepInput style={this.state.cep_error ? {borderColor:"red"} : {}} required onChange={this.updateState} value={this.state.cep} id="cep" class="form-control" name="inputCep" placeholder="CEP" required="" type="text"/>
                                                </div>
                                                
                                                <div class="form-group col-md-6">
                                                    <label for="inputAddress">Rua</label>
                                                    <input style={this.state.street_error ? {borderColor:"red"} : {}} required onChange={this.updateState} value={this.state.street} id="street" class="form-control" name="inputEmail" placeholder="Rua" type="text"/>
                                                </div>
                                                <div class="form-group col-md-3">
                                                    <label for="inputNumber">Número</label>
                                                    <input style={this.state.number_error ? {borderColor:"red"} : {}} required onChange={this.updateState} value={this.state.number} id="number" class="form-control" name="inputNumber" placeholder="Número" type="text"/>
                                                </div>
                                                <div class="form-group col-md-5">
                                                    <label for="inputNeighborhood">Bairro</label>
                                                    <input style={this.state.neighborhood_error ? {borderColor:"red"} : {}} required onChange={this.updateState} value={this.state.neighborhood} id="neighborhood" class="form-control" name="inputNeighborhood" placeholder="Bairro" type="text"/>
                                                </div>

                                                <div class="form-group col-md-5">
                                                    <label for="inputNeighborhood">Cidade</label>
                                                    <input style={this.state.city_error ? {borderColor:"red"} : {}} required onChange={this.updateState} value={this.state.city} id="city" class="form-control" name="inputCity" placeholder="Cidade" type="text"/>
                                                </div>

                                                <div class="form-group col-md-2">
                                                    <label for="inputProvice">Estado</label>
                                                    <input style={this.state.uf_error ? {borderColor:"red"} : {}} required onChange={this.updateState} maxLength={2} value={this.state.uf} id="uf" class="form-control" name="inputProvice" placeholder="Estado" type="text"/>
                                                </div>

                                                <div class="form-group col-md-12">
                                                    <label for="inputComplement">Complemento</label>
                                                    <input onChange={this.updateState} value={this.state.complement} id="complement" class="form-control" name="inputComplement" placeholder="Complemento" type="text"/>
                                                </div>

                                                <div class="clearfix"></div>
                                            </div>
                                            <div class="col-md-12 peers jc-c">
                                                <button onClick={this.clear} class="btn fsz-md  btn-clear peers ai-c pX-5 pY-0 mB-5 bdrs-2 mR-5 cur-p c-client-secondary" type="button">Cancelar</button>
                                                <button onClick={this.nextPage} class="btn fsz-md btn btn-clear peers ai-c pX-5 pY-0 mB-5 bdrs-2 mR-5 cur-p c-client-default" type="button">Dados secretária
                                                    <i class="fa fa-angle-right mL-10"></i>
                                                </button>
                                            </div>
                                        </div>
                                        :
                                        <div class="aba2-data">
                                            <h4 class="m-0 mB-10">
                                                <i class="fa fa-user mR-10 mB-10 c-client-default"></i>Dados da Secretária</h4>
                                            <div class="clearfix"></div>
                                            <div class="form-group col-md-8">
                                                <label for="inputSecretaryName">Nome</label>
                                                <input style={this.state.secretaryName_error ? {borderColor:"red"} : {}} required onChange={this.updateState} value={this.state.secretaryName} id="secretaryName" class="form-control" name="inputSecretaryName" placeholder="Nome da Secretária" type="text"/>
                                            </div>
                                            <div class="form-group col-md-4">
                                                <label for="inputSecretaryDocument">CPF</label>
                                                <CpfInput style={this.state.secretaryCpf_error ? {borderColor:"red"} : {}} required onChange={this.updateState} value={this.state.secretaryCpf} id="secretaryCpf" class="form-control" name="inputSecretaryDocument" placeholder="CPF" type="text"/>
                                            </div>
                                            <div class="form-group col-md-12">
                                                <label for="inputEmail">E-mail</label>
                                                <input style={this.state.secretaryEmail_error ? {borderColor:"red"} : {}} required onChange={this.updateState} value={this.state.secretaryEmail} id="secretaryEmail" class="form-control" name="inputEmail" placeholder="E-mail" type="email"/>
                                            </div>
                                            <div class="col-md-12">
                                                <label>Selecione o modo de cadastro da clínica</label>
                                                <select style={{float:"right"}} onChange={this.updateState} id="registerMode" value={this.state.registerMode}>
                                                    <option value={1}>CPF do Médico</option>
                                                    <option value={2}>CNPJ da Clínica</option>
                                                </select>
                                                <br/>
                                                <br/>
                                                {this.state.registerMode == 2 ?
                                                    <div class="form-group col-md-6" style={{paddingLeft:0}}>
                                                        <label for="inputCnpj">CNPJ</label>
                                                        <CnpjInput style={this.state.cnpj_error ? {borderColor:"red"} : {}} required onChange={this.updateState} value={this.state.cnpj} id="cnpj" class="form-control" name="inputcnpj" placeholder="CNPJ" type="text"/>
                                                    </div>
                                                    :
                                                    <div class="form-group col-md-6" style={{paddingLeft:0}}>
                                                        <label for="cpfDoctor">CPF do Médico</label>
                                                        <CpfInput style={this.state.cpfDoctor_error ? {borderColor:"red"} : {}} required onChange={this.updateState} value={this.state.cpfDoctor} id="cpfDoctor" class="form-control" name="inputcpfDoctor" placeholder="CPF do Médico" type="text"/>
                                                    </div>
                                                }
                                            </div>
                                            <div class="col-md-12 peers jc-c">
                                                    <button onClick={() => this.setState({page:0})} class="btn fsz-md  btn-clear peers ai-c pX-5 pY-0 mB-5 bdrs-2 mR-5 cur-p c-client-secondary" type="button">
                                                        <i class="fa fa-angle-left mR-10"></i>Dados Clínica</button>
                                                        <button onClick={this.check} class="btn fsz-md  btn-clear peers ai-c pX-5 pY-0 mB-5 bdrs-2 mR-5 cur-p c-client-default" type="button">
                                                            Salvar</button>
                                            </div>

                                        </div>
                                        }
                                    </form>
                                </div>
                            </div>
                        </div>

                        <div class="bdT p-10 peers jc-sb ai-c bgc-client-default">
                            <div class="peers ai-c">
                                <span class="badge badge-pill bgc-pink-500 c-white mL-10">{this.state.page + 1}</span>
                                <h4 class="m-0 c-client-default-inverse">{ this.state.page == 0 ? "Clínica" : " Secretária"}</h4>
                            </div>

                            <button onClick={()=> this.state.page == 0 ? this.nextPage() : this.check()} class="btn btn-clear peers ai-c pX-5 pY-0 bdrs-2 mR-3 cur-p c-client-default-inverse fsz-md" type="button">
                                {this.state.page == 0 ? "Secretária" : "Enviar"}
                                <i class="fa fa-angle-right fsz-xl"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="bcg-overlay open-details"></div>
            </div>
        )
	}
}

export default ClinicRegister;



// WEBPACK FOOTER //
// ./src/pages/clinic/ClinicRegister.js